"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsNotificationsMenuHeader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _Notifications = _interopRequireDefault(require("@mui/icons-material/Notifications"));
var _notifications = require("../../service/notifications/notifications");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _WarningAmber = _interopRequireDefault(require("@mui/icons-material/WarningAmber"));
var _InfoOutlined = _interopRequireDefault(require("@mui/icons-material/InfoOutlined"));
var _HighlightOffRounded = _interopRequireDefault(require("@mui/icons-material/HighlightOffRounded"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsNotificationsMenuHeader = () => {
  const LIMIT = 99;
  const getCount = items => {
    let count = 0;
    let unread = 0;
    for (let group of Object.values(items)) {
      group.forEach(item => {
        if (!item.read) unread++;
        count++;
      });
    }
    return [count, unread];
  };
  const [items, setItems] = (0, _react.useState)(_notifications.Notifications.items);
  const [count, setCount] = (0, _react.useState)(0);
  const [unread, setUnread] = (0, _react.useState)(0);
  const [limited, setLimited] = (0, _react.useState)(false);
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    const updateCounts = updatedItems => {
      if (updatedItems) {
        const [total, unreadCount] = getCount(updatedItems);
        setCount(total);
        setUnread(Math.min(unreadCount, LIMIT));
        setLimited(unreadCount > LIMIT);
        setItems(updatedItems);
      }
    };
    updateCounts();
    _notifications.Notifications.onChange(updateCounts);
  }, [_notifications.Notifications]);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const readItem = (id, group) => {
    _notifications.Notifications.read(id, group);
  };
  const text_notification = _reactIntlUniversal.default.get("Notification").d("Notification");
  const iconMap = {
    info: /*#__PURE__*/_react.default.createElement(_InfoOutlined.default, {
      style: {
        marginRight: '10px',
        minWidth: '16px'
      }
    }),
    warning: /*#__PURE__*/_react.default.createElement(_WarningAmber.default, {
      style: {
        marginRight: '10px',
        minWidth: '16px'
      }
    }),
    error: /*#__PURE__*/_react.default.createElement(_HighlightOffRounded.default, {
      style: {
        marginRight: '10px',
        minWidth: '16px'
      }
    })
  };
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    color: "inherit",
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_material.Badge, {
    badgeContent: "".concat(unread).concat(limited ? '+' : ''),
    color: unread > 0 ? "error" : "primary"
  }, /*#__PURE__*/_react.default.createElement(_Notifications.default, null))), /*#__PURE__*/_react.default.createElement(_material.Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    disabled: true
  }, count, " ", text_notification, count !== 1 ? 's' : ''), Object.entries(items).map(_ref => {
    let [group, notifications] = _ref;
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      key: group
    }, /*#__PURE__*/_react.default.createElement(_material.Divider, null), /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      disabled: true
    }, /*#__PURE__*/_react.default.createElement(_material.Badge, {
      badgeContent: notifications.length,
      color: "primary",
      style: {
        marginRight: '1rem'
      }
    }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body1"
    }, /*#__PURE__*/_react.default.createElement("b", null, group))), notifications.map(item => /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: item.id,
      onClick: () => readItem(item.id, group),
      style: {
        paddingLeft: '28px',
        backgroundColor: item.read ? 'inherit' : '#f5f5f5'
      }
    }, item.icon && iconMap[item.icon], /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2"
    }, /*#__PURE__*/_react.default.createElement("b", null, item.title), ": ", item.text))));
  })));
};
exports.DmsNotificationsMenuHeader = DmsNotificationsMenuHeader;